export default __webpack_public_path__ + "static/moneybus_small-4-91336a0e766eeb99792949e97d50378d.webp";